import React from "react";
import Grid from "@material-ui/core/Grid";
import Footer from "../common/Footer";
import SliderDev from "./components/SliderDev";
import mediaQuery from "../common/mediaQuery";
// estilos
import { Title, Text, Button } from "../common/styled";
import "./style.css";

import ScrollAnimation from "react-animate-on-scroll";
import SliderInfra from "./components/SliderInfra";

const Body = (props) => {
  const { text, language } = props;
  const { small } = mediaQuery();

  return (
    <div className="Body-wrapper">
      <Grid
        container
        justify="center"
        alignItems="center"
        alignContent="center"
        className="Body-section2"
        style={{ marginBottom: "6vh" }}
      ></Grid>

      <div className="servicesContainer">
        <ScrollAnimation animateIn="bounceInUp" animateOnce={true}>
          <h1 className={!small ? "servicesTitle" : "serviceTitleMobile"}>
            {text.getTextWeWant()}
          </h1>

          <img
            class="line"
            alt="linha"
            src={require("../../images/servicos/linha.png")}
          />
        </ScrollAnimation>

        <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
          <h2 className={!small ? "departmentTitle" : "departmentTitleMobile"}>
            {text.getDepartment()[0]}
          </h2>
        </ScrollAnimation>

        <ScrollAnimation animateIn="bounceInRight" animateOnce={true}>
          <SliderDev text={text} />
        </ScrollAnimation>
      
        <div className="resumeContainer">
          {!small && (
            <div className="bigImageContainer">
              <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
                (
                  <img
                    src={require("../../images/servicos/benefits_dev.png")}
                    className="bigImage"
                    alt="big"
                  />
              </ScrollAnimation>
            </div>
          )}

          <div
            className="rightColumnContainer"
            style={small ? { height: "50vh" } : {}}
          >
            <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
              <div className="rowContainer">
                <img
                  className="icon"
                  src={require("../../images/icones/benefit_money.png")}
                  alt="teste"
                />
                {!small && <h2>{text.getDevBenefits()[0]}</h2>}
                {small && <h3>{text.getDevBenefits()[0]}</h3>}
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
              <div className="rowContainer">
                <img
                  className="icon"
                  src={require("../../images/icones/benefit_increase.png")}
                  alt="teste"
                />
                {!small && <h2>{text.getDevBenefits()[1]}</h2>}
                {small && <h3>{text.getDevBenefits()[1]}</h3>}
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
              <div className="rowContainer">
                <img
                  className="icon"
                  src={require("../../images/icones/benefit_software.png")}
                  alt="teste"
                />
                {!small && <h2>{text.getDevBenefits()[2]}</h2>}
                {small && <h3>{text.getDevBenefits()[2]}</h3>}
              </div>
            </ScrollAnimation>
          </div>
        </div>

        {language !== "us" && (
          <>
            <ScrollAnimation animateIn="bounceInRight" animateOnce={true}>
              <h2
                className={!small ? "departmentTitle" : "departmentTitleMobile"}
              >
                {text.getDepartment()[1]}
              </h2>
            </ScrollAnimation>

            <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
              <SliderInfra text={text} />
            </ScrollAnimation>
          </>
        )}

        <div className="resumeContainer" style={{ marginBottom: "0" }}>
          <div className="bigImageContainer">
            <ScrollAnimation animateIn="bounceInLeft" animateOnce={true}>
              {!small && (
                <img
                  src={require("../../images/servicos/benefits_infra.png")}
                  className="bigImage"
                  alt="big"
                />
              )}
            </ScrollAnimation>
          </div>

          <div
            className="rightColumnContainer"
            style={small ? { height: "50vh" } : {}}
          >
            <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
              <div className="rowContainer">
                <img
                  className="icon"
                  src={require("../../images/icones/benefit_agility.png")}
                  alt="teste"
                />
                {small && <h3>{text.getInfraBenefits()[0]}</h3>}
                {!small && (
                  <h2 style={{ textAlign: "left" }}>
                    {text.getInfraBenefits()[0]}
                  </h2>
                )}
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
              <div className="rowContainer">
                <img
                  className="icon"
                  src={require("../../images/icones/benefit_security.png")}
                  alt="teste"
                />
                {small && <h3>{text.getInfraBenefits()[1]}</h3>}
                {!small && (
                  <h2 style={{ textAlign: "left" }}>
                    {text.getInfraBenefits()[1]}
                  </h2>
                )}
              </div>
            </ScrollAnimation>

            <ScrollAnimation animateIn="fadeIn" animateOnce={true}>
              <div className="rowContainer">
                <img
                  className="icon"
                  src={require("../../images/icones/benefit_money.png")}
                  alt="teste"
                />
                {small && <h3>{text.getInfraBenefits()[2]}</h3>}
                {!small && (
                  <h2 style={{ textAlign: "left" }}>
                    {text.getInfraBenefits()[2]}
                  </h2>
                )}
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>

      {!small && (
        <Grid
          className={small ? "LetsTalMobile" : "LetsTalk"}
          alignItems="center"
          justify="center"
        >
          <ScrollAnimation animateIn="fadeIn" animateOnce={true} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Title
              style={{
                width: "100vw",
                textAlign: "center",
                marginBottom: "5vh",
                paddingTop: "6vh",
                fontSize: "7vh"
              }}
              color="#fff"
              size={small ? "5vh" : "9vh"}
              weight="900"
            >
              {text.getTextoKnowMore()[0]}
            </Title>
            
            <Button
              className="ButtonTalk"
              // width={small ? "70vw" : ""}
              onClick={() => props.routeChange("contato")}
            >
              {text.getTextoKnowMore()[1]}
            </Button>
          </ScrollAnimation>
        </Grid>
      )}

      <Footer text={text} language={props.language} />
    </div>
  );
};

export default Body;
